import { c as _c } from "react/compiler-runtime";
import { useFeatureFlag, useIsMobile } from '@newfront-insurance/admin-ui';
import { cn } from '@newfront-insurance/core-ui/v2';
import { useMemo } from 'react';
import { ChatContainer } from '../components/chat-container';
import { ChatContent } from '../components/chat-content';
import { AccountSelector, ChatHeader, NewChatButton, ToggleSidebar } from '../components/chat-header';
import { ChatHeaderActions } from '../components/chat-header/chat-header-actions';
import { ChatRoot } from '../components/chat-root';
import { ChatSidebar, ChatSidebarFilterTabs, ChatSidebarHistory, ChatSidebarNewChat, ChatSidebarSearch, ChatSidebarSettingsButton } from '../components/chat-sidebar';
import { useChatOverlayContext } from '../contexts/chat-overlay-context';
import { createDefaultDataPartRenderers, createDefaultToolRenderers } from '../lib/default-renderers';
import { NovaChatProvider } from '../providers';
import { NavigatorGraphPayload } from './navigator-graph-payload';

/**
 * Container component that renders the chat UI.
 * Reads all props from context - no prop drilling needed.
 * All child components are self-contained and manage their own state.
 */
export function NovaChatContainer() {
  const $ = _c(29);
  const {
    isVisible,
    authProvider,
    userUuid,
    accountUuid,
    userScopes: scopes,
    initialMessages,
    isLoadingMessages: loading,
    placeholder,
    isStandaloneMode,
    isSidebarOpen,
    isFullscreen
  } = useChatOverlayContext();
  const isNovaSourcesRenderingEnabled = useFeatureFlag("nova-sources-rendering", false);
  const {
    isMobile
  } = useIsMobile();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createDefaultToolRenderers();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  t0 = t1;
  const toolRenderers = t0;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDefaultDataPartRenderers();
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  t2 = t3;
  const dataPartRenderers = t2;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NavigatorGraphPayload />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChatSidebar><ChatSidebarNewChat /><ChatSidebarSettingsButton /><ChatSidebarSearch /><ChatSidebarFilterTabs /><ChatSidebarHistory /></ChatSidebar>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = (isStandaloneMode || isFullscreen) && isSidebarOpen && !isMobile;
  const t7 = (isStandaloneMode || isFullscreen) && !isSidebarOpen && !isMobile;
  let t8;
  if ($[4] !== t6 || $[5] !== t7) {
    t8 = cn("flex size-full flex-col", {
      "ml-[253px]": t6,
      "ml-[63px]": t7
    });
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== isMobile) {
    t9 = <ChatHeader>{isMobile ? <><ToggleSidebar /><div className="flex flex-1 justify-center"><AccountSelector /></div><NewChatButton /></> : <><AccountSelector /><ChatHeaderActions /></>}</ChatHeader>;
    $[7] = isMobile;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== isNovaSourcesRenderingEnabled || $[10] !== loading || $[11] !== placeholder) {
    t10 = <ChatContent isLoading={loading} toolRenderers={toolRenderers} dataPartRenderers={dataPartRenderers} placeholder={placeholder} enableSourcesRendering={isNovaSourcesRenderingEnabled} />;
    $[9] = isNovaSourcesRenderingEnabled;
    $[10] = loading;
    $[11] = placeholder;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <ChatRoot>{t9}{t10}</ChatRoot>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t8) {
    t12 = <div className={t8}>{t11}</div>;
    $[16] = t11;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== accountUuid || $[20] !== authProvider || $[21] !== initialMessages || $[22] !== scopes || $[23] !== t12 || $[24] !== userUuid) {
    t13 = <NovaChatProvider authProvider={authProvider} userUuid={userUuid} accountUuid={accountUuid} scopes={scopes} initialMessages={initialMessages}>{t4}{t5}{t12}</NovaChatProvider>;
    $[19] = accountUuid;
    $[20] = authProvider;
    $[21] = initialMessages;
    $[22] = scopes;
    $[23] = t12;
    $[24] = userUuid;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== isVisible || $[27] !== t13) {
    t14 = <ChatContainer isVisible={isVisible}>{t13}</ChatContainer>;
    $[26] = isVisible;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}